import { useAuth } from '@/contexts/auth-context';

/**
 * The brand segment every discount code preview is built on: the brand the
 * session currently works in, which is also what the backend stamps on the
 * code. The placeholder only shows while the session has no brand resolved.
 */
export function usePreviewBrandName(): string {
  const { user } = useAuth();
  return user?.currentBrand?.name || 'Brand';
}
